var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-n6 mb-10"},[('move-sameday' == _vm.name)?_c('service-sameday'):_vm._e(),('move-express' == _vm.name)?_c('service-express'):_vm._e(),('move-transit' == _vm.name)?_c('service-transits'):_vm._e(),_c('other-service')],1)}
var staticRenderFns = []

export { render, staticRenderFns }